import { Injectable } from '@angular/core';

export class PowerBIParam {
  lwfBusinessProcessInstanceId: number;
  sCurrentInstanceData: string;  
  sDataCaption: string;
  lwfBusinessProcessStateDataId: number;
  ReportName: string;
  DataTypeParameter: string;
}

export class PowerBIReportConfig {
  id: string;
  accessToken: string;
  embedUrl: string;
}
